module.exports = __webpack_public_path__ + "img/left01.23fd9db1.webp";